// extracted by mini-css-extract-plugin
export default {"actions":"ModalAction_actions__qJjiB","button--alt":"ModalAction_button--alt__6GdPW","button":"ModalAction_button__Lvkxv"};